import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useChowaTheme } from '../config/chowaThemeContext';

const TimeMonitoringSeriesSelection = () => {
  const { clearSeriesColor } = useChowaTheme();

  // 時間監視選択ページではデフォルトテーマに戻す
  useEffect(() => {
    clearSeriesColor();
  }, [clearSeriesColor]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" sx={{ textAlign: 'center', color: 'text.secondary' }}>
        サイドバーから目的のシリーズを選択してください
      </Typography>
    </Box>
  );
};

export default TimeMonitoringSeriesSelection; 